module.exports = __webpack_public_path__ + "static/media/IMG_0578_Reduced.e654fe00.jpg";